import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { EventEmitter } from '@angular/core';

/**
 * @title Update Service
 * @since 1.0.0
 * 
 * @description Service to handle updates for the application.
 * It listens for version updates and emits an event when a new version is available.
 * It also provides a method to activate the update and reload the page.
 * 
 */
@Injectable({
	providedIn: 'root',
})
export class UpdateService {

	/**
	 * An event emitter that emits when a new version is available.
	 * Components can subscribe to this event to get notified about updates.
	 * @type {EventEmitter<void>}
	 * @since 1.0.0
	 */
	public updateAvailable: EventEmitter<void> = new EventEmitter();

	/**
	 * @param {SwUpdate} updates - Angular service for checking and activating updates.
	 * @since 1.0.0
	 */
	constructor(
		private updates: SwUpdate
	) {
		// Check if the service worker is enabled and listen for version updates
		if (this.updates.isEnabled) {
			this.updates.versionUpdates.subscribe((event) => {
				if (event.type === 'VERSION_READY') {
					// Emit an event when a new version is available
					this.updateAvailable.emit();
				}
			});
		}
	}

	/**
	 * Activates the update and reloads the page.
	 * This method is called when the user confirms that they want to update the application.
	 * @since 1.0.0
	 * @returns {void}
	 */
	activateUpdate(): void {
		this.updates.activateUpdate().then(() => document.location.reload());
	}
}